// RecoverSafelySection.js
import React from 'react';
import { ArrowRight } from 'lucide-react';
import recoverSafelyImage from '../assets/recover-safely-image.jpg';

const RecoverSafelySection = () => {
  const services = [
    'Medication reminders to stay on track with your recovery plan',
    'Monitoring for changes in condition and reporting concerns',
    'Transportation to follow-up appointments',
    'Light housekeeping to maintain a clean and safe environment',
    'Meal preparation that aligns with post-surgery dietary needs',
    'Assistance with bathing, dressing, and personal hygiene',
    'Mobility support to reduce fall risk and promote movement as advised'
  ];

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Image */}
          <div className="relative">
            <img
              src={recoverSafelyImage}
              alt="Two women looking at a tablet together"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>

          {/* Right Content */}
          <div>
            <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Post-Operative Care
            </p>
            <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Recover Safely and Comfortably with Trusted Post-Operative Care
            </h2>

            <div className="space-y-4 text-muted text-base leading-relaxed mb-8 max-w-lg">
              <p>
                Recovering from surgery can be physically and emotionally demanding, especially at home. Wei Care offers personalised post-operative care to support a safe, comfortable recovery and help reduce the risk of complications.
              </p>

              <p className="text-ink font-medium">Our trained carers assist with a range of tasks during the healing process, including:</p>
            </div>

            <ul className="space-y-5 mb-8">
              {services.map((service, index) => (
                <li key={index} className="flex items-start gap-4">
                  <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-full border border-primary text-primary">
                    <ArrowRight size={16} />
                  </span>
                  <span className="text-muted text-sm leading-relaxed">{service}</span>
                </li>
              ))}
            </ul>

            <p className="text-muted text-base leading-relaxed max-w-lg">
              Whether you need short-term help or ongoing support, we are here to make your recovery smoother and more manageable, so you can focus on healing.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecoverSafelySection;
